// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'

class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.render = this.render.bind(this)
    this.deviceHasHover = window.matchMedia('screen and (hover: hover)').matches
    this.slides = this.els.slides
    this.defaultSectionTitle = this.els.title?.element.dataset.defaultTitle
  }

  setupListeners () {
    super.setupListeners()

    function awaitEvent (key) {
      return new Promise((resolve, reject) => {
        window.addEventListener(key, e => {
          if (e.detail.successful) {
            resolve(e)
          } else {
            reject(e)
          }
        })
      })
    }

    Promise.allSettled([awaitEvent('cartRecommendationsDataIsReady')]).then(
      results => {
        results.forEach(data => {
          if (data.status === 'rejected') {
            console.error(data.reason)
            return
          }

          const products = data.value.detail.data
          this.render(products)
        })
      },
    )
  }

  async render (products) {
    const currentUrl = new URL(window.location)

    const rootUrl = this.dataset.rootUrl || '/'

    products.forEach(product => {
      const sectionUrl = new URL(product.__tagalys_fields.link)

      if (rootUrl !== '/' && !sectionUrl.pathname.startsWith(rootUrl)) {
        const base = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`
        sectionUrl.pathname = base + sectionUrl.pathname.replace(/^\//, '')
      }

      const preferredImageGender =
        currentUrl.searchParams.get('gender') ||
        this.dataset.preferredImageGender
      if (preferredImageGender) {
        sectionUrl.searchParams.set('view', preferredImageGender)
      }

      const asyncCard = `<li class="keen-slider__slide" data-push-cart-recommendations-el="slide">
        <section-async
          class="prd-Card_Async"
          section-id="product-cart-recommendation-card"
          url="${sectionUrl.toString()}"
          aria-busy="true"
        ></section-async>
      </li>`

      this.slides?.element?.insertAdjacentHTML('beforeend', asyncCard)
    })

    this.slides.element.classList.add('keen-slider')
    this.carousel = this.initialiseCarousel()

    if (this.deviceHasHover) {
      document.addEventListener('mouseover', evt => {
        let element = evt.target
        while (element && element !== document) {
          if (element.classList.contains('prd-Card_Recommendation')) {
            this.showHoveredProductDetails(element)
            break
          }

          element = element.parentNode
        }
      })
    }
  }

  showHoveredProductDetails (card) {
    const product = {
      title: card.dataset.productTitle,
      price: card.dataset.productPrice,
    }

    this.els.title.element.innerText = product.title
    this.els.price.element.innerText = product.price

    card.addEventListener('mouseleave', evt => {
      let element = evt.target
      while (element && element !== document) {
        if (element.classList.contains('prd-Card_Recommendation')) {
          this.revertSectionTitle()
          break
        }

        element = element.parentNode
      }
    })
  }

  revertSectionTitle () {
    if (!this.els.title.element) {
      return
    }

    this.els.title.element.innerText = this.defaultSectionTitle
  }

  initialiseCarousel () {
    return new KeenSlider(this.slides.element, {
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 5,
            spacing: 10,
          },
        },
        '(min-width: 1700px)': {
          slides: {
            perView: 2.5,
            spacing: 9,
          },
        },
      },
      slides: {
        perView: 2.1,
        spacing: 6,
      },
    })
  }

  useArrows ({ next, previous } = {}) {
    /** @param {KeenSliderInstance} carousel */
    return carousel => {
      next?.addEventListener('click', carousel.next)
      previous?.addEventListener('click', carousel.prev)

      const updateButtonStates = () => {
        const { abs, maxIdx, min } = carousel.track.details

        if (next) {
          next.disabled = abs === maxIdx
        }

        if (previous) {
          previous.disabled = abs === min
        }
      }

      carousel.on('created', updateButtonStates)
      carousel.on('slideChanged', updateButtonStates)
      carousel.on('optionsChanged', updateButtonStates)
    }
  }

  set slides (el) {
    this._slides = el
  }

  get slides () {
    return this._slides
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}
